// src/redux/company/companySelectors.js

// ✅ Add Company
export const selectAddCompanyData = (state) => state?.company?.addCompany?.data;
export const selectAddCompanyLoading = (state) => state?.company?.addCompany?.loading;
export const selectAddCompanyError = (state) => state?.company?.addCompany?.error;

// ✅ Update Company
export const selectUpdateCompanyData = (state) => state?.company?.updateCompany?.data;
export const selectUpdateCompanyLoading = (state) => state?.company?.updateCompany?.loading;
export const selectUpdateCompanyError = (state) => state?.company?.updateCompany?.error;

// ✅ Company List
export const selectCompanyList = (state) => state?.company?.getCompanyList?.data || [];
export const selectCompanyListLoading = (state) => state?.company?.getCompanyList?.loading;
export const selectCompanyListError = (state) => state?.company?.getCompanyList?.error;
export const selectCompanyListTotal = (state) => state?.company?.getCompanyList?.total || 0;

// ✅ Company Detail
export const selectCompanyDetail = (state) => state?.company?.getCompanyById?.data;
export const selectCompanyDetailLoading = (state) => state?.company?.getCompanyById?.loading;
export const selectCompanyDetailError = (state) => state?.company?.getCompanyById?.error;

// ✅ Company Coaches
export const selectCompanyCoaches = (state) =>
  state?.company?.getCompanyCoaches?.data || [];
export const selectCompanyCoachesLoading = (state) =>
  state?.company?.getCompanyCoaches?.loading;
export const selectCompanyCoachesError = (state) =>
  state?.company?.getCompanyCoaches?.error;
export const selectCompanyCoachesTotal = (state) =>
  state?.company?.getCompanyCoaches?.total || 0;

// ✅ Remove Company Coach
export const selectRemoveCompanyCoachData = (state) => state?.company?.removeCompanyCoach?.data;
export const selectRemoveCompanyCoachLoading = (state) => state?.company?.removeCompanyCoach?.loading;
export const selectRemoveCompanyCoachError = (state) => state?.company?.removeCompanyCoach?.error;

// ✅ Archive Company
export const selectArchiveCompanyData = (state) => state?.company?.archiveCompany?.data;
export const selectArchiveCompanyLoading = (state) => state?.company?.archiveCompany?.loading;
export const selectArchiveCompanyError = (state) => state?.company?.archiveCompany?.error;

// ✅ Update Company HR
export const selectUpdateCompanyHRData = (state) => state?.company?.updateCompanyHR?.data;
export const selectUpdateCompanyHRLoading = (state) => state?.company?.updateCompanyHR?.loading;
export const selectUpdateCompanyHRError = (state) => state?.company?.updateCompanyHR?.error;

// ✅ Get Company Stats
export const selectCompanyStatsData = (state) => state?.company?.getCompanyStats?.data;
export const selectCompanyStatsLoading = (state) => state?.company?.getCompanyStats?.loading;
export const selectCompanyStatsError = (state) => state?.company?.getCompanyStats?.error;

// ✅ Get Company Activity Logs
export const selectCompanyActivityLogs = (state) => state?.company?.getCompanyActivityLogs?.data || [];
export const selectCompanyActivityLogsLoading = (state) => state?.company?.getCompanyActivityLogs?.loading;
export const selectCompanyActivityLogsError = (state) => state?.company?.getCompanyActivityLogs?.error;
export const selectCompanyActivityLogsTotal = (state) => state?.company?.getCompanyActivityLogs?.total || 0; // ✅ Newly Added Selector

// ✅ Combined
export const selectCompanyState = (state) => state?.company;